// Colors

export const theme = {
    evTeal: "#3A9A83",
    voltBlue: "#173346",
    eLime: "#C3E000",
    ecoMint: "#E1F2E0",
    gray: "#B2B2B220"
}